import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Typo Generator',
		description:
			'Install an AI that deliberately misspells every word on campaign merchandise.'
	},
	{
		name: 'Wrong Size Labels',
		description:
			'All clothing sizes are randomly assigned. XS might be XXXL, who knows?'
	},
	{
		name: 'Invisible Ink',
		description:
			'Print all campaign slogans in disappearing ink. Very eco-friendly!'
	},
	{
		name: 'Quantum Fabric',
		description:
			'Shirts exist in multiple states until observed. May cause temporal paradoxes.'
	},
	{
		name: 'Self-Destructing Merch',
		description:
			'All merchandise now comes with a built-in self-destruct timer.'
	},
	{
		name: 'Quantum Merch Delivery',
		description:
			'Merchandise now arrives before it was ordered. Customers are confused.'
	},
	{
		name: 'Antimatter Printing',
		description:
			'Print merchandise using antimatter. Each item annihilates upon contact.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Merchandise Factory'],
	departments[DepartmentIds['Merchandise Factory']].basePrice * 3,
	UpgradeIds.MefExponent1
)

export default array
